import React, { useState } from 'react';
import './Hero.css';
import profileImage from '../assets/641BD8E3-6E48-4536-B220-AC04DB539539_1_201_a.jpeg'; 
import dashboardImage from '../assets/Screenshot 2025-10-08 at 10.59.34 PM.png';
import landingPageImage from '../assets/Screenshot 2025-10-09 at 4.56.24 PM.png';
import rockPaperScissorImage from '../assets/Screenshot 2025-10-09 at 4.54.31 PM.png';

const Hero = () => {
  const [activeProject, setActiveProject] = useState(0);
  const [emailCopied, setEmailCopied] = useState(false);

  const handleEmailCopy = async () => {
    try {
      await navigator.clipboard.writeText('nxv200004@utdallas.edu');
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy email:', err);
      // Fallback: open mailto
      window.location.href = 'mailto:nxv200004@utdallas.edu';
    }
  };

  const projects = [
    {
      id: 1,
      title: "Dashboard Template - Basic",
      description: "Social media dashboard template, made vanilla css, javascript.",
      tech: ["js", "TypeScript", "css", "html"],
      image: dashboardImage,
      link: "https://darkferrari.github.io/dashboard/",
      github: "#"
    },
    {
      id: 5,
      title: "Landing Page - template",
      description: "Cross-platform landing page/ home page.",
      tech: ["html", "css", "javascript"],
      image: landingPageImage,
      link: "https://darkferrari.github.io/odin-landing-page/",
      github: "#"
    },
    {
      id: 4,
      title: "Chatbot AI - In development...",
      description: "AI chatbot made with python and openai api.",
      tech: ["React ","Python","Openai Api", "Mcp","Fastapi"],
      image: "https://via.placeholder.com/300x200/ff6b6b/ffffff?text=ExpenseManager",
      link: "#",
      github: "#"
    },
    {
      id: 2,
      title: "Ecommerce Website - In development...",
      description: "Ecommerce website for selling products online, made with React,java and springboot.",
      tech: ["React","JavaScript", "MongoDB","Java","Springboot"],
      image: "https://via.placeholder.com/300x200/0077ff/ffffff?text=TaskTracker",
      link: "#",
      github: "#"
    },
    
    {
      id: 3,
      title: "Payment Gateway Mobile - In development...",
      description: "Cross-platform mobile app for expense tracking and budget management.",
      tech: ["React Native", "Firebase", "Redux","Java"],
      image: "https://via.placeholder.com/300x200/ff6b6b/ffffff?text=ExpenseManager",
      link: "#",
      github: "#"
    },
    
    {
      id: 6,
      title: "Rock Paper Scissors",
      description: "Game - Rock Paper Scissors.",
      tech: ["jekyll", "javascript","html","css"],
      image: rockPaperScissorImage,
      link: "https://darkferrari.github.io/RockPaperScissor/",
      github: "#",
    },
    
  ];

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        {/* Hero Main Section - Side by Side Layout */}
        <div className="hero-main">
          {/* Hero Intro Section - Left Side */}
          <div className="hero-intro">
            <div className="profile-image-container">
              <img 
                src={profileImage} 
                alt="Neeraj Reddy" 
                className="profile-image"
              />
            </div>
          <div className="hero-content">
            <h1 className="hero-title">
              Hello, I'm <span className="highlight">Neeraj!</span>
            </h1>
            <p className="hero-subtitle">
              Full Stack Dev & PM
            </p>
            <p className="hero-description">
              Welcome to my portfolio! I'm a passionate Software Developer and product manager with expertise in frontend and backend development, UI/UX, and a passion for creating digital products.
            </p>
            <p className="hero-description">
              I like to build digital products using new technologies, which can be further used to build products . 
            </p>
            <div className="hero-links">
              <div className="contact-me-container">
                <button onClick={handleEmailCopy} className="btn btn-primary">
                  {emailCopied ? 'Email Copied!' : 'Contact Me'}
                </button>
                <div className="email-tooltip">Click to copy: nxv200004@utdallas.edu</div>
              </div>
              <a href="https://github.com/DarkFerrari" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                GitHub
              </a>
              <div className="linkedin-container">
                <a href="https://www.linkedin.com/in/neerajreddyv" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  LinkedIn
                </a>
                <div className="linkedin-tooltip">linkedin.com/in/neeraj-reddy-</div>
              </div>
            </div>
          </div>
          </div>

          {/* Tech Stack Tile - Right Side */}
          <div className="tech-stack-tile">
            <div className="tech-stack-content">
              <h3 className="tech-stack-title">This site is built using following tech stack</h3>
              <p className="tech-stack-description"> •Javascript •React •Node.js •Express •Tailwind Css •Railway</p>
            </div>
          </div>
        </div>

        {/* Projects Section - Below Hero Intro */}
        <div className="hero-projects">
          <div className="projects-section">
            <h2 className="projects-title">Featured Projects</h2>
            <div className="projects-grid">
              {projects.map((project, index) => (
                <div 
                  key={project.id} 
                  className={`project-card ${activeProject === index ? 'active' : ''}`}
                  onMouseEnter={() => setActiveProject(index)}
                >
                  <div className="project-image">
                    <img src={project.image} alt={project.title} />
                    <div className="project-overlay">
                      <div className="project-links">
                        <a href={project.link} className="project-link" target="_blank" rel="noopener noreferrer">
                          View Live
                        </a>
                        <a href={project.github} className="project-link" target="_blank" rel="noopener noreferrer">
                          GitHub
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="project-content">
                    <h3 className="project-title">{project.title}</h3>
                    <p className="project-description">{project.description}</p>
                    <div className="project-tech">
                      {project.tech.map((tech, techIndex) => (
                        <span key={techIndex} className="tech-tag">{tech}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
